import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { ListboxOptionWrapper, ListboxOptionCheckbox, ListboxOptionMain, ListboxOptionInfo } from "./listbox-option.styles.es.js";
import { Checkbox } from "../checkbox/checkbox.es.js";
import "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import { useScrollIntoView } from "../../hooks/use-scroll-into-view.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  highlighted: PropTypes.bool,
  indent: PropTypes.bool,
  index: PropTypes.number.isRequired,
  info: PropTypes.string,
  listRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired,
  multi: PropTypes.bool,
  onHighlight: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps = {
  disabled: false,
  highlighted: false,
  indent: false,
  info: void 0,
  multi: false,
  selected: false,
  value: void 0
};
const ListboxOption = ({
  children,
  disabled,
  highlighted,
  indent,
  index,
  info,
  listRef,
  multi,
  onHighlight,
  onSelect,
  selected,
  value
}) => {
  const ref = useRef();
  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      if (!disabled) {
        onSelect(value);
      }
    },
    [disabled, onSelect, value]
  );
  const handleMouseEnter = useCallback(() => {
    onHighlight(index);
  }, [index, onHighlight]);
  useScrollIntoView(listRef, highlighted ? ref : void 0);
  return /* @__PURE__ */ jsxs(
    ListboxOptionWrapper,
    {
      ref,
      "aria-current": !multi && selected,
      "aria-selected": highlighted,
      indent,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      role: "option",
      children: [
        multi && /* @__PURE__ */ jsx(ListboxOptionCheckbox, { children: /* @__PURE__ */ jsx(Checkbox, { checked: selected, disabled }) }),
        /* @__PURE__ */ jsx(ListboxOptionMain, { children }),
        info && /* @__PURE__ */ jsx(ListboxOptionInfo, { children: info })
      ]
    }
  );
};
ListboxOption.propTypes = propTypes;
ListboxOption.defaultProps = defaultProps;
export {
  ListboxOption
};
